import { useMediaQuery, useTheme } from "@mui/material";

const useUiStore = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "lg"));

  return {
    isDesktop,
    isMobile,
    isTablet,
  };
};

export default useUiStore;
